import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Label, TextInput } from "flowbite-react";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ReporteExamenTXCrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "REPORTE EXAMEN TRABAJADOR";
  const { control, reset, handleSubmit } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const mutateFechaTX = useMutationData({
    url: `/fecha-toxi/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-toxi"],
  });

  const mutateExamenTX = useMutationData({
    url: `/examentx/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "examentx"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
      {/* Table section */}
      <div>
        <table className={`w-full text-sm border-collapse border ${isDarkMode ? "border-gray-600 bg-gray-700 text-white" : "border-slate-700 bg-white text-gray-800"}`}>
          <tbody>
            <tr>
              {/* Columna izquierda: título */}
              <td className={`w-1/2 border-2 text-center font-semibold ${isDarkMode ? "border-gray-600 bg-cyan-700 text-white" : "border-slate-700 bg-customCyan text-gray-800"}`}>
                TRABAJADOR / REPORTE EXÁMEN
                <br />
                (Prevención de sustancias de abuso)
              </td>
              {/* Columna derecha: contenido */}
              <td className={`w-1/2 border-2 text-left ${isDarkMode ? "border-gray-600 bg-gray-700 text-white" : "border-slate-700 bg-white text-gray-800"}`}>
                <div className="flex items-center space-x-4 p-2">
                  <Label className="flex-shrink-0">
                    No. DE CONTROL O FOLIO:
                  </Label>
                  <Controller
                    name="folio_tx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="folio_tx"
                        type="text"
                        className="w-40px"
                        style={isDarkMode ? {
                          backgroundColor: '#374151',
                          color: '#e5e7eb',
                          borderColor: '#4b5563'
                        } : {}}
                        {...field}
                      />
                    )}
                  />
                </div>
                <div className="flex items-center space-x-4 p-2">
                  <Label className="flex-shrink-0">FECHA:</Label>
                  <Controller
                    name="fecha_examentx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput 
                        id="fecha_examentx" 
                        type="date" 
                        style={isDarkMode ? {
                          backgroundColor: '#374151',
                          color: '#e5e7eb',
                          borderColor: '#4b5563'
                        } : {}}
                        {...field} />
                    )}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <h4 className={`text-left ${isDarkMode ? "text-white" : "text-gray-800"}`}>MODULO I.-EMPRESA</h4>
        {/* Table section */}
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700">
            <tbody>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  NOMBRE DEL CENTRO DE TRABAJO:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="nombrecentro_trabajotx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="nombrecentro_trabajotx"
                        type="text"
                        {...field}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  DOMICILIO:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="domicilio_trabajotx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="domicilio_trabajotx"
                        type="text"
                        {...field}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna única que abarca ambas columnas */}
                <td
                  colSpan={2}
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                >
                  CON BASE A LA NOM-030-STPS-2009 Y EL REGLAMENTO FEDERAL DE
                  SEGURIDAD Y SALUD EN EL TRABAJO, SE REALIZA EL EXÁMEN PARA LA
                  PREVENCIÓN DE TOXICOMANIAS EN EL CENTRO DE TRABAJO POR:
                  <br />
                  {/* Radio buttons centrados y con más espacio entre ellos */}
                  <div className="flex justify-center space-x-8 mt-4">
                    <label>
                      <Controller
                        name="motivo_trabajotx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="motivo_trabajotx"
                            type="radio"
                            {...field}
                            name="motivo_trabajotx"
                            value="Nuevo Ingreso"
                          />
                        )}
                      />{" "}
                      NUEVO INGRESO
                    </label>
                    <label>
                      <Controller
                        name="motivo_trabajotx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="motivo_trabajotx"
                            type="radio"
                            {...field}
                            name="motivo_trabajotx"
                            value="Programa Preventivo"
                          />
                        )}
                      />{" "}
                      PROGRAMA PREVENTIVO
                    </label>
                    <label>
                      <Controller
                        name="motivo_trabajotx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="motivo_trabajotx"
                            type="radio"
                            {...field}
                            name="motivo_trabajotx"
                            value="Otro"
                          />
                        )}
                      />{" "}
                      OTRO
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-[25px]"></div>
        <h4 className="text-left">MODULO II.- TRABAJADOR</h4>
        {/* Table section */}
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700">
            <tbody>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  NOMBRE DEL EVALUADO:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Label
                    value={`${queryEvaluado.data?.nombre || ""} ${
                      queryEvaluado.data?.apellido_paterno || ""
                    } ${queryEvaluado.data?.apellido_materno || ""}`}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  EMPRESA EN LA QUE LABORA:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Label
                    value={queryEvaluado.data?.empresa_id?.nombre || ""}
                  ></Label>
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  FECHA DE NACIMIENTO:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Label
                    value={
                      queryEvaluado.data?.fecha_nacimiento
                        ? (() => {
                            const [year, month, day] =
                              queryEvaluado.data.fecha_nacimiento.split("-");
                            return `${day}/${month}/${year}`;
                          })()
                        : ""
                    }
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  SE IDENTIFICA CON:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="identifica_tx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput id="identifica_tx" type="text" {...field} />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna única que abarca ambas columnas */}
                <td
                  colSpan={2}
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                >
                  MANIFIESTO QUE MI ESTADO DE SALUD EN GENERAL ES:
                  <br />
                  {/* Radio buttons centrados y con más espacio entre ellos */}
                  <div className="flex justify-center space-x-8 mt-4">
                    <label>
                      <Controller
                        name="estado_saludtx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estado_saludtx"
                            type="radio"
                            {...field}
                            name="estado_saludtx"
                            value="Bueno"
                          />
                        )}
                      />{" "}
                      BUENO
                    </label>
                    <label>
                      <Controller
                        name="estado_saludtx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estado_saludtx"
                            type="radio"
                            {...field}
                            name="estado_saludtx"
                            value="Regular"
                          />
                        )}
                      />{" "}
                      REGULAR
                    </label>
                    <label>
                      <Controller
                        name="estado_saludtx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estado_saludtx"
                            type="radio"
                            {...field}
                            name="estado_saludtx"
                            value="Malo"
                          />
                        )}
                      />{" "}
                      MALO
                    </label>
                    <label>
                      <Controller
                        name="estado_saludtx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estado_saludtx"
                            type="radio"
                            {...field}
                            name="estado_saludtx"
                            value="CON PROBLEMAS CRÓNICOS"
                          />
                        )}
                      />{" "}
                      CON PROBLEMAS CRÓNICOS
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                {/* Columna única que abarca ambas columnas */}
                <td
                  colSpan={2}
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                >
                  EN LOS ÚLTIMOS 30 DÍAS HE TOMADO MEDICAMENTOS:
                  <br />
                  {/* Radio buttons centrados y con más espacio entre ellos */}
                  <div className="flex justify-center space-x-8 mt-4">
                    <label>
                      <Controller
                        name="tomar_medicamentostx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="tomar_medicamentostx"
                            type="radio"
                            {...field}
                            name="tomar_medicamentostx"
                            value="Si"
                          />
                        )}
                      />{" "}
                      SI
                    </label>
                    <label>
                      <Controller
                        name="tomar_medicamentostx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="tomar_medicamentostx"
                            type="radio"
                            {...field}
                            name="tomar_medicamentostx"
                            value="No"
                          />
                        )}
                      />{" "}
                      NO
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                {/* Columna única que abarca ambas columnas */}
                <td
                  colSpan={2}
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                >
                  EN CASO AFIRMATIVO, DESCRIBA EL NOMBRE DEL MEDICAMENTO(S) Y
                  PORQUE LOS TOMÓ:
                  <br />
                  <div>
                    <Controller
                      name="nombre_medicamentotx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="nombre_medicamentotx"
                          type="text"
                          {...field}
                          placeholder="Nombre de los medicamentos..."
                        />
                      )}
                    />
                    <br />
                    <Controller
                      name="porque_medicamentotx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <textarea
                          id="porque_medicamentotx"
                          {...field}
                          style={isDarkMode ? {
                            backgroundColor: '#374151',
                            color: '#e5e7eb',
                            borderColor: '#4b5563'
                          } : {}}
                          className={`w-full h-32 p-3 border-2 rounded-md resize-none focus:outline-none focus:ring-2 ${isDarkMode ? "border-gray-600 bg-gray-700 text-gray-200 focus:ring-blue-500" : "border-slate-700 bg-white text-gray-800 focus:ring-customCyan"}`}
                          placeholder="Escriba aquí el porque..."
                        />
                      )}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-[25px]"></div>
        <h4 className="text-left">MODULO III.- AUTORIZACIÓN DEL TRABAJADOR</h4>
        {/* Table section */}
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700">
            <tbody>
              <tr>
                {/* Columna única que abarca ambas columnas */}
                <td
                  colSpan={2}
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                >
                  <div className="text-justify">
                    EL QUE SUSCRIBE{" "}
                    <Label
                      value={`${queryEvaluado.data?.nombre || ""} ${
                        queryEvaluado.data?.apellido_paterno || ""
                      } ${queryEvaluado.data?.apellido_materno || ""}`}
                      className="inline-block w-auto uppercase font-bold"
                    />{" "}
                    MANIFIESTO QUE LEÍ EL MODULO I DESCRITO EN ESTE FORMATO Y
                    AUTORIZO LA REALIZACIÓN DEL ANÁLISIS CLÍNICO, PARA LO CUAL
                    DONO UNA MUESTRA DE ORINA, VERIFICANDO PREVIAMENTE QUE EL
                    REACTIVO Y RECIPIENTE RECOLECTOR SON NUEVOS, ESTÁN SELLADOS
                    Y SU FECHA DE CADUCIDAD ES VIGENTE. ASIMISMO, DOY MI
                    CONSENTIMIENTO PARA ENVIAR ESTA MUESTRA DE ORINA A UN
                    LABORATORIO EN CASO DE OBTENER UN RESULTADO “NO NEGATIVO” Y
                    SEA REQUERIDA UNA PRUEBA CONFIRMATORIA. ASIMISMO; AUTORIZO A
                    LA EMPRESA SKA TRACKING AND SECURITY S.A. DE C.V. PARA QUE
                    PROPORCIONE TODA LA INFORMACIÓN, DOCUMENTOS Y TODA LA
                    INFORMACIÓN QUE DERIVEN DE LAS EVALUACIONES DE PRUEBAS DE
                    CONFIANZA QUE SE ME REALICEN.
                    <div className="mt-[50px]"></div>
                    <h5 className="text-center">
                      _____________________
                      <br />
                      Firma del Evaluado
                    </h5>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-[25px]"></div>
        <h4 className="text-left">
          MODULO IV.- METODO DE DETECCIÓN (USO EXCLUSIVO DE LA EMPRESA)
        </h4>
        {/* Table section */}
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700 table-fixed">
            <tbody>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  PANEL MULTIDROGAS DE:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="panel_multidrogastx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="panel_multidrogastx"
                        type="text"
                        {...field}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  VASO MULTIDROGAS DE:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="vaso_multidrogastx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="vaso_multidrogastx"
                        type="text"
                        {...field}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/3 border-2 border-slate-700 text-left font-semibold">
                  TEMPERATURA:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/3 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="temperatura_tx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput id="temperatura_tx" type="text" {...field} />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  RANGO NORMAL:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <div className="flex justify-center space-x-8">
                    <label>
                      <Controller
                        name="rango_normaltx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="rango_normaltx"
                            type="radio"
                            {...field}
                            name="rango_normaltx"
                            value="true"
                          />
                        )}
                      />{" "}
                      SI
                    </label>
                    <label>
                      <Controller
                        name="rango_normaltx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="rango_normaltx"
                            type="radio"
                            {...field}
                            name="rango_normaltx"
                            value="false"
                          />
                        )}
                      />{" "}
                      NO
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-[25px]"></div>
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700 table-fixed">
            <thead>
              <tr>
                <th className="border-2 border-slate-700 text-left font-semibold p-2">
                  RESULTADO
                </th>
                <th className="border-2 border-slate-700 text-left font-semibold p-2">
                  PRUEBA EMPLEADA
                </th>
                <th className="border-2 border-slate-700 text-left font-semibold p-2">
                  DATOS DEL RECOLECTOR
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Fila de "Resultado" con tres celdas */}
              <tr>
                <td className="border-2 border-slate-700">
                  <table className="w-full">
                    <tbody>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          No.
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          DROGA
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          ( + )
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          ( - )
                        </td>
                      </tr>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          1
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          MARIHUANA (THC)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="marihuanatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="marihuanatx"
                                type="radio"
                                {...field}
                                name="marihuanatx"
                                value="Positivo"
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="marihuanatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="marihuanatx"
                                type="radio"
                                {...field}
                                name="marihuanatx"
                                value="Negativo"
                              />
                            )}
                          />
                        </td>
                      </tr>

                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          2
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          COCAINA (COC)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="cocainatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="cocainatx"
                                type="radio"
                                {...field}
                                name="cocainatx"
                                value="Positivo"
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="cocainatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="cocainatx"
                                type="radio"
                                {...field}
                                name="cocainatx"
                                value="Negativo"
                              />
                            )}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          3
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          OPIACEOS (OPI)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="opiaceostx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="opiaceostx"
                                type="radio"
                                {...field}
                                name="opiaceostx"
                                value="Positivo"
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="opiaceostx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="opiaceostx"
                                type="radio"
                                {...field}
                                name="opiaceostx"
                                value="Negativo"
                              />
                            )}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          4
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          ANFETAMINA (AMP)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="anfetaminatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="anfetaminatx"
                                type="radio"
                                {...field}
                                name="anfetaminatx"
                                value="Positivo"
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="anfetaminatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="anfetaminatx"
                                type="radio"
                                {...field}
                                name="anfetaminatx"
                                value="Negativo"
                              />
                            )}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          5
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          METANFETAMINA (mAMP)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="metanfetaminatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="metanfetaminatx"
                                type="radio"
                                {...field}
                                name="metanfetaminatx"
                                value="Positivo"
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="metanfetaminatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="metanfetaminatx"
                                type="radio"
                                {...field}
                                name="metanfetaminatx"
                                value="Negativo"
                              />
                            )}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          6
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          BENZODIACEPINA (BZO)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="benzodiacepinatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="benzodiacepinatx"
                                type="radio"
                                {...field}
                                name="benzodiacepinatx"
                                value="Positivo"
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="benzodiacepinatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="benzodiacepinatx"
                                type="radio"
                                {...field}
                                name="benzodiacepinatx"
                                value="Negativo"
                              />
                            )}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                {/* Fila de "Prueba Empleada" con celda combinada que abarca toda la columna */}
                <td
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                  rowSpan={7}
                >
                  <Label>No. LOTE:</Label>
                  <Controller
                    name="lotetx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="lotetx"
                        type="text"
                        {...field}
                      />
                    )}
                  />
                  <div className="mt-[25px]"></div>
                  <Label>FECHA CADUCIDAD:</Label>
                  <Controller
                    name="fecha_caducidadtx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="fecha_caducidadtx"
                        type="date"
                        {...field}
                      />
                    )}
                  />
                </td>
                {/* Fila de "Datos del recolector" con celda combinada que abarca toda la columna */}
                <td
                  className="border-2 border-slate-700 font-semibold p-2"
                  rowSpan={7}
                >
                  <div className="text-center">
                  <Controller
                    name="nombre_recolectortx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="nombre_recolectortx"
                        type="text"
                        {...field}
                      />
                    )}
                  />
                    <Label className="text-center">
                      _______________________________
                    </Label>
                    <br />
                    <Label>Nombre</Label>
                  </div>
                  <br />
                  <div className="text-center">
                    <Label className="text-center">
                      _______________________________
                    </Label>
                    <br />
                    <Label>Firma</Label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <div className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
          <form
            onSubmit={handleSubmit((data) => {
          console.log(data);

          // Preparar datos del formulario
          const formData = {
            ...data,
          };

          // Actualizar fecha de evaluación toxicológica
          mutateFechaTX.mutate(
            {
              data: { fecha_examentx: data.fecha_examentx },
              tipo: "put",
            },
            {
              onSuccess: () => {
                mutateExamenTX.mutate(
                  {
                    data: formData,
                    tipo: "post",
                  },
                  {
                    onSuccess: () => {
                      navigate(`/toxicologica/${evaluadosList_id}`);
                    },
                    onError: (error) => {
                      console.error(
                        "Error al guardar datos del Examen:",
                        error
                      );
                    },
                  }
                );
              },
              onError: (error) => {
                console.error(
                  "Error al guardar Fecha de Evaluación Toxicológica:",
                  error
                );
              },
            }
          );
        })}
        className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}
      >
        {renderHeader()}

        {currentPage === 1 && renderPage1()}

        <div className={`mt-6 p-4 flex justify-between ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
          {/* Botón Cancelar */}
          {currentPage === 1 && (
            <Button
              color="red"
              className={`ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-700" : ""}`}
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(`/toxicologica/${evaluadosList_id}`);
              }}
            >
              Cancelar
            </Button>
          )}

          {currentPage > 1 && (
            <Button
              color="blue"
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Anterior
            </Button>
          )}

          {/* Botón Guardar */}
          {currentPage === 1 && (
            <div className="flex space-x-4">
              <button
                type="submit"
                className="bg-green-500 text-white rounded px-4 py-2"
              >
                Guardar
              </button>
            </div>
          )}
        </div>
      </form>
    </div>
  </div>
</div>
  );
};
